import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  Button,
  Table,
  Space,
  Dropdown,
  notification,
  Tooltip,
  Descriptions,
  Modal,
} from "antd";
import { DeleteOutlined, DownOutlined, CheckCircleOutlined, 
  CloseCircleOutlined
 } from "@ant-design/icons";
import TemplatePointsDetailsForm from "../components/Forms/TemplatePointsDetailsForm";
import TemplateForm from "../components/Forms/TemplateForm";
import AddTemplatePointsTable from "../pages/AddTemplatePointsTable";
import axios from "axios";
import "moment-timezone";
import GlobalContext from "../utils/GlobalContext";
import { v4 as uuidv4 } from "uuid";
import MessageDialog from "../components/MessageDialog";
import LoadingModal from "../utils/LoadingModal";
// import formatTimestamp from "../utils/FormatTimestamp";
import { useParams } from "react-router-dom";

const PAGE_SIZE = 15;

const TemplateDetails = () => {
  const globals = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);
  //point-details***************************
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
  });
  //****************************************
  //templates
  const [showTemplateForm, setShowTemplateForm] = useState(false);
  const [isEditTemplate, setIsEditTemplate] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState(null);
  //****************************************
  //AddTemplatePointsTable
  const [showAddTemplatePointsTable, setShowAddTemplatePointsTable] =
    useState(false);
  //****************************************
  const [showTemplatePointsForm, setShowTemplatePointsForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentPointDetails, setCurrentPointDetails] = useState(null);
  const [messageVisible, setMessageVisible] = useState(false);
  const [details, setDetails] = useState([]);

  const { id } = useParams();

  const columns = [
    // {
    //   title: "ID",
    //   dataIndex: "id",
    //   key: "id",
    //   width: 50,
    // },
    {
      title: "Nombre del punto",
      dataIndex: "name",
      key: "name",
      // width: 200,
      render: (_, record) => (
        <Tooltip title={record.description}>
          <span>{record.name}</span>
        </Tooltip>
      ),
    },
    // {
    //   title: "Tipo de reunión",
    //   dataIndex: "meeting_type_name",
    //   key: "meeting_type",
    // },
    // {
    //   title: "Departamento",
    //   dataIndex: "department_name",
    //   key: "department",
    // },
    {
      title: "Tipo de punto",
      dataIndex: "point_type_name",
      key: "point_type",
    },
    {
      title: "Clasificación",
      dataIndex: ["classification", "name"],
      key: "classification",
    },
    {
      title: "🕑",
      dataIndex: "duration",
      key: "duration",
      // width: 50,
      render: (text) => {
        return (text) ? `${text} min`: `0 min`;
      },
    },
    {
      title: "Estatus",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        // mostrar icono y texto basado en el estado
        return text === "ACTIVO" || text === "ACTIVE" ? (
          <span style={{ color: "green" }}>
            <CheckCircleOutlined style={{ marginRight: 8 }} />
            Activo
          </span>
        ) : (
          <span style={{ color: "red" }}>
            <CloseCircleOutlined style={{ marginRight: 8 }} />
            Inactivo
          </span>
        );
      },
    },
    {
      title: "Opciones",
      key: "actions",
      width: 80,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "1",
                  label: (record?.status === "ACTIVO" || record?.status === "ACTIVE") ? "Inactivar" : "Activar",
                  icon: (record?.status === "ACTIVO" || record?.status === "ACTIVE") ? <CloseCircleOutlined /> : <CheckCircleOutlined />,
                  onClick: () => handleActionClick("status", record),
                },
                // {
                //   key: "1",
                //   label: "Editar",
                //   icon: <EditOutlined />,
                //   onClick: () => handleActionClick("edit", record),
                // },
                {
                  key: "2",
                  label: "Eliminar",
                  icon: <DeleteOutlined />,
                  onClick: () => handleActionClick("delete", record),
                },
              ],
            }}
          >
            <Button icon={<DownOutlined />} shape="circle" />
          </Dropdown>
        </Space>
      ),
    },
  ];

  const fetchData = useCallback(
    async (newPagination) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-point-detail/${id}`,
          {
            headers: {
              "x-token": globals.token,
            },
            params: {
              page,
              limit: pageSize,
            },
          }
        );
        setData(response?.data?.data.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data.count,
          });
        }
        notification.success({
          message: "Información obtenida exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -2) {
          // notification.warning({
          //   message: "No hay información disponible!",
          //   placement: "bottomRight",
          //   duration: 2,
          // });
          setData([]);
        } else {
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
            duration: 2,
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  const fetchCurrentData = useCallback(
    async () => {
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/consult-template/${id}`,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        setCurrentTemplate(response?.data?.data);
        setDetails([
          // {
          //   key: 1,
          //   label: "ID",
          //   children: response?.data?.data.id,
          // },
          {
            key: 2,
            label: "Nombre",
            children: response?.data?.data.name,
          },
          {
            key: 3,
            label: "Departamento",
            children: response?.data?.data.department.name,
          },
          {
            key: 4,
            label: "Tipo de reunión",
            children: response?.data?.data.meeting_type.name,
          },
          // {
          //   key: 5,
          //   label: "Invitados",
          //   children: response?.data?.data.guests,
          // },
        ]);
      } catch (error) {
        console.error("Error fetching data:", error.response);
        if (error?.response?.data.status === -2) {
          notification.warning({
            message: "No hay información disponible!",
            placement: "bottomRight",
          });
          setData([]);
        } else {
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
          });
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  useEffect(() => {
    fetchCurrentData();
    fetchData(null);
  }, [fetchData, fetchCurrentData]);

  const handleActionClick = async (key, record) => {
    if (key === "edit") {
      setIsEdit(true);
      setCurrentPointDetails(record);
      setShowTemplatePointsForm(true);
    } 
    else if (key === "delete") {
      setCurrentPointDetails(record);
      setMessageVisible(true);
    } 
    else if (key === "status") {
      try {
        await axios.put(
          `${globals.SERVICE_API_DB}/v1/update-point-details-status/${record.id}`,
          {
            status: record.status === "ACTIVO" || record.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
          },
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        record.status = record.status === "ACTIVO" || record.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
        setCurrentPointDetails(record);
        notification.success({
          message: "Estatus actualizado exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.error("Error updating status:", error.response);
        notification.error({
          message: "Error actualizando estatus!",
          placement: "bottomRight",
        });
      }
    }
  };

  async function handleTableChange(newPagination) {
    fetchData(newPagination);
  }

  const saveTemplatePointForm = async ({ status, newTemplatePoint }) => {
    setShowTemplatePointsForm(false);
    if (isEdit) {
      setIsEdit(false);
      notification.success({
        message: "Punto de plantilla editado exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
    if (status === "created") {
      setData([newTemplatePoint, ...data]);
    }

    notification.success({
      message: "Punto de plantilla creado exitosamente!",
      placement: "bottomRight",
      duration: 2,
    });
  };

  const saveTemplateForm = async ({ status, newTemplatePoint }) => {
    setShowTemplateForm(false);
    if (isEditTemplate) {
      notification.success({
        message: "Plantilla editada exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      setDetails([
        {
          key: 1,
          label: "ID",
          children: currentTemplate.id,
        },
        {
          key: 2,
          label: "Nombre",
          children: currentTemplate.name,
        },
        {
          key: 2,
          label: "Tipo de reunión",
          children: currentTemplate.meeting_type.name,
        },
        {
          key: 4,
          label: "Departamento",
          children: currentTemplate.department.name,
        },
        {
          key: 5,
          label: "Invitados",
          children: currentTemplate.guests,
        },
      ]);
      return;
    }
  };

  const closeTemplateForm = () => {
    setShowTemplateForm(false);
  };

  const closeTemplatePointForm = () => {
    setShowTemplatePointsForm(false);
    setIsEdit(false);
    setCurrentPointDetails(null);
  };

  const deletePointDetails = async () => {
    setMessageVisible(false);
    try {
      await axios.delete(
        `${globals.SERVICE_API_DB}/v1/delete-point-detail/${currentPointDetails.id}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setData(data.filter((item) => item.id !== currentPointDetails.id));
      notification.success({
        message: "Punto de plantilla exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
    } catch (err) {
      console.log(err.response.data);
      notification.error({
        message: "Error eliminando departamento",
        placement: "bottomRight",
        duration: 2,
      });
      return;
    }
  };

  const handleRefresh = () => {
    fetchCurrentData();
    fetchData(null);
  };

  const closeAddTemplatePointsTable = () => {
    setShowAddTemplatePointsTable(false);
    fetchData(null);
  };

  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <Button
          onClick={() => {
            window.history.back();
          }}
          style={{ marginRight: "8px" }}
        >
          Regresar
        </Button>
        <h2 style={{ marginRight: "16px" }}>
          Plantilla: {currentTemplate?.name}
        </h2>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        <Button
          onClick={() => {
            setIsEditTemplate(true);
            setShowTemplateForm(true);
          }}
          style={{ marginRight: "8px" }}
        >
          Editar
        </Button>
        <Button
          onClick={handleRefresh}
          disabled={loading}
          style={{ marginRight: "8px" }}
        >
          Refrescar
        </Button>
      </div>
      <Descriptions bordered title="Información" items={details} />
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <h4 style={{ marginBottom: 16 }}>Puntos en plantilla</h4>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        <Button
          type="primary"
          onClick={() => {
            setShowAddTemplatePointsTable(true);
          }}
          style={{ marginRight: "8px" }}
        >
          Agregar
        </Button>
      </div>
      <div
        className="site-layout-background h-auto"
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          margin: 0,
          height: "auto",
          minHeight: "350px",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <Table
          rowKey={(r) => uuidv4()}
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      </div>
      <LoadingModal open={loading} />

      <TemplatePointsDetailsForm
        open={showTemplatePointsForm}
        onFinish={saveTemplatePointForm}
        onCancel={closeTemplatePointForm}
        isEdit={isEdit}
        currentTemplatePoint={currentPointDetails}
      />

      <TemplateForm
        open={showTemplateForm}
        onFinish={saveTemplateForm}
        onCancel={closeTemplateForm}
        isEdit={isEditTemplate}
        currentTemplate={currentTemplate}
      />
      <Modal
        open={showAddTemplatePointsTable}
        onCancel={closeAddTemplatePointsTable}
        footer={[
          <Button key="ok" type="primary" onClick={closeAddTemplatePointsTable}>
            Cerrar
          </Button>,
        ]}
        width={1000}
      >
        <AddTemplatePointsTable
          currentTemplateId={id}
          meeting_type_id={currentTemplate?.meetingTypesId}
          department_id={currentTemplate?.departmentsId}
        />
      </Modal>
      <MessageDialog
        visible={messageVisible}
        title="Está seguro de eliminar este punto de plantilla?"
        message="Esta acción no se puede deshacer."
        onOk={deletePointDetails}
        onCancel={() => setMessageVisible(false)}
        confirm={true}
      />
    </div>
  );
};

export default TemplateDetails;
